export const partition = <T>(data: T[], filter: (item: T) => boolean): [T[], T[]] => {
    const result = data.reduce(
        (acc: [T[], T[]], item: T) => {
            if (filter(item)) acc[0].push(item);
            else acc[1].push(item);
            return acc;
        },
        [[], []],
    );

    return result;
};
